<div class="row" [ngStyle]="style" (click)="goToCategory(caja.data.url)">
  <div class="container-img relative p-0" [ngStyle]="style">
    <img
      [ngSrc]="caja.data.image"
      class="bg"
      [ngStyle]="style"
      [alt]="caja?.data?.title"
      [height]="style['height.px']"
      [width]="style['width.px']"
    />
  </div>
  <div
    class="sm:col-12 flex justify-content-center"
    style="cursor: pointer"
    [ngStyle]="style_title"
  >
    <h4 [ngStyle]="style_text">
      {{ caja.data.title }}
    </h4>
  </div>
  <div class="sm:col-12 overlay" [ngStyle]="style_overlay"></div>
</div>
